import { Bar, mixins } from 'vue-chartjs';
// import globalOptionsMixin from '@/components/Charts/globalOptionsMixin';

export default {
   name: 'bar-chart',
   extends: Bar,
   mixins: [mixins.reactiveProp],
   // mixins: [mixins.reactiveProp, globalOptionsMixin],
   props: {
      options: {
         type: Object,
         default: () => ({})
      }
   },
   data() {
      return {
         ctx: null
      };
   },
   mounted() {
      this.$watch(
         'chartData',
         (newVal, oldVal) => {
            if (!oldVal) {
               this.renderChart(this.chartData, this.options);
            }
         },
         { immediate: true }
      );
   }
};

// import { Bar } from 'vue-chartjs';

// export default {
//    extends: Bar,
//    props: ['chartData', 'options'],
//    mounted() {
//       this.renderChart(this.chartData, this.options);
//    }
// };
